module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }